import { EditContactOutDto, EditContactInDto } from '../../../types/contact.dto'

export const EDIT_CONTACT = 'EDIT_CONTACT'
export const EDIT_CONTACT_SUCCESS = 'EDIT_CONTACT_SUCCESS'
export const EDIT_CONTACT_ERROR = 'EDIT_CONTACT_ERROR'
export const RESET_EDIT_CONTACT = 'RESET_EDIT_CONTACT'

export interface EditContact {
  type: typeof EDIT_CONTACT
  payload: EditContactOutDto
}

export interface EditContactSuccess {
  type: typeof EDIT_CONTACT_SUCCESS
  payload: EditContactInDto
}

export interface EditContactError {
  type: typeof EDIT_CONTACT_ERROR
  payload: string | boolean
}

export interface ResetEditContact {
  type: typeof RESET_EDIT_CONTACT
  payload: null
}
export interface State {
  data: EditContactInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditContact | EditContactSuccess | EditContactError | ResetEditContact
